<a
    class="collection-card selenium-collection-card {{ gtmPrefix }}"
    [routerLink]="resource.getRouterLink()"
    [attr.data-gtmresultindex]="gtmDataCardNumber"
>
    <app-collection-card-poster
        [posterImage]="resource.getPosterImage(500, 500)"
        [alt]="resource.getPosterImageAlt('original-square')"
        [title]="resource.title"
        [searchImage]="
            resource.getPosterImageIfExists('original-square', 500, 500)
        "
        [resourceCount]="resource.resourcesCount"
        [gtmPrefix]="gtmPrefix"
        [absoluteUrl]="getAbsoluteUrl()"
    >
    </app-collection-card-poster>
</a>
